import React, { useEffect, useState } from "react";
import { graphql, StaticQuery } from "gatsby";
import { RichText as PrismicRichText } from "prismic-reactjs";

import {
  AbrioFact,
  AccordionGroup,
  FlexGrid,
  PageHeader,
  RichText,
  SectionWrapper,
  SEO,
  Text
} from "src/components";

import serializer from "src/utils/serializer";
import linkResolver from "src/utils/linkResolver";

function MainContent({ location, description, questions }) {
  const [initialQuestion, setInitialQuestion] = useState(undefined);

  useEffect(() => {
    if (window.location.hash) {
      let foundIndex = 1;
      questions.forEach((question, index) => {
        if (question.id === window.location.hash.replace("#", "")) {
          foundIndex = index;
        }
      });
      if (foundIndex !== -1) {
        setInitialQuestion("accordionGroupquestions" + foundIndex);
      } else {
        setInitialQuestion("");
      }
    } else {
      setInitialQuestion("");
    }
  }, []);

  useEffect(() => {
    window.location.hash = window.location.hash;
    window.scrollBy(0, -72);
  }, [initialQuestion]);

  return (
    <article
      css={`
        width: 67%;
        @media (max-width: 64rem) {
          width: 100%;
        }
      `}
    >
      <section
        css={`
          margin: 64px 0;
        `}
      >
        <Text fontSize={3}>{description}</Text>
      </section>
      {initialQuestion !== undefined && (
        <AccordionGroup
          id="questions"
          preExpanded={[initialQuestion]}
          items={questions.map(question => {
            return {
              id: question.id,
              heading: question.question,
              children: (
                <RichText>
                  {question.answer &&
                    PrismicRichText.render(
                      question.answer,
                      linkResolver,
                      serializer
                    )}
                </RichText>
              )
            };
          })}
        />
      )}
    </article>
  );
}

const Body = ({
  description,
  questions,
  factNumber,
  factIllustration,
  fact
}) => (
  <SectionWrapper>
    <FlexGrid gutterX={[8]} gutterY={[6]}>
      <MainContent description={description} questions={questions} />
      {factIllustration && (
        <AbrioFact
          number={factNumber}
          children={fact}
          color="brand.purple"
          type={factIllustration}
        />
      )}
    </FlexGrid>
  </SectionWrapper>
);

function YourQuestionsAnsweredPage({ preview }) {
  return (
    <StaticQuery
      query={graphql`
        {
          prismicQuestions {
            dataString
          }
        }
      `}
      render={data => {
        let page = JSON.parse(data.prismicQuestions.dataString);
        if (preview) {
          page = preview;
        }
        return (
          <>
            <SEO
              image={page.seo_image && page.seo_image.url}
              title={page.seo_title && PrismicRichText.asText(page.seo_title)}
              description={
                page.seo_description &&
                PrismicRichText.asText(page.seo_description)
              }
            />
            <PageHeader
              heading={page.header && PrismicRichText.asText(page.header)}
              color="brand.purple"
            />
            <Body
              description={
                page.page_description &&
                PrismicRichText.render(
                  page.page_description,
                  linkResolver,
                  serializer
                )
              }
              factIllustration={page.fact_illustration}
              factNumber={page.fact_number}
              fact={
                page.fact &&
                PrismicRichText.render(page.fact, linkResolver, serializer)
              }
              questions={page.questions}
            />
          </>
        );
      }}
    />
  );
}

export default YourQuestionsAnsweredPage;
